/**
 * Валидация кириллицы для поля ФИО
 * @param text - текст для проверки
 * @returns объект с результатом валидации и описанием ошибки
 */
export const validateCyrillic = (text: string): { isValid: boolean; error?: string } => {
  // Удаляем пробелы для проверки
  const trimmedText = text.trim();
  
  // Если поле пустое, это нормально (проверку на обязательность делаем отдельно)
  if (!trimmedText) {
    return { isValid: true };
  }
  
  // Регулярное выражение для кириллицы, пробелов и дефисов
  // Разрешаем: русские и казахские буквы, пробелы, дефисы
  const cyrillicRegex = /^[а-яёәіңғүұқөһА-ЯЁӘІҢҒҮҰҚӨҺ\s\-]+$/;
  
  if (!cyrillicRegex.test(text)) {
    return { 
      isValid: false, 
      error: 'ФИО должно содержать только кириллицу' 
    };
  }
  
  // Проверяем минимальную длину (должно быть хотя бы имя и фамилия)
  const words = trimmedText.split(/\s+/).filter(word => word.length > 0);
  if (words.length < 2) {
    return { 
      isValid: false, 
      error: 'Введите фамилию и имя' 
    };
  }
  
  // Проверяем что каждое слово содержит минимум 2 символа
  const hasShortWords = words.some(word => word.length < 2);
  if (hasShortWords) {
    return { 
      isValid: false, 
      error: 'Каждая часть ФИО должна содержать минимум 2 символа' 
    };
  }
  
  return { isValid: true };
};

/**
 * Фильтрация ввода для поля ФИО - оставляет только кириллицу, пробелы и дефисы
 * @param text - исходный текст
 * @returns отфильтрованный текст
 */
export const filterCyrillicInput = (text: string): string => {
  // Разрешаем только кириллицу, пробелы и дефисы
  return text.replace(/[^а-яёәіңғүұқөһА-ЯЁӘІҢҒҮҰҚӨҺ\s\-]/g, '');
};
